import { Box, BoxProps } from '@amzn/ring-ui-react-components';
import { SeekInput } from './SeekInput';
interface DurationProps extends BoxProps {
  duration: number;
  loaded: number;
  played: number;
  'data-testid'?: string;
  handleSeekMouseDown: (e: any) => void;
  handleSeekMouseUp: (e: any) => void;
  handleSeekChange: (e: any) => void;
}

export const Duration = ({
  duration,
  loaded,
  played,
  handleSeekMouseDown,
  handleSeekChange,
  handleSeekMouseUp,
  ...props
}: DurationProps) => (
  <Box {...props} display="flex" width="100%" gridGap={3}>
    <Box width="100%" position="relative">
      <Box
        height="4px"
        backgroundColor="rgba(255, 255, 255, .5)"
        width="100%"
        position="absolute"
        top="calc(50% - 2px)"
        borderRadius="4px"
      ></Box>
      <Box
        height="4px"
        backgroundColor="#FFFFFF"
        width={loaded * 100 + '%'}
        position="absolute"
        top="calc(50% - 2px)"
        borderRadius="4px"
      ></Box>
      <Box
        height="4px"
        backgroundColor="#1998D5"
        width={played * 100 + '%'}
        position="absolute"
        top="calc(50% - 2px)"
        borderRadius="4px 0px 0px 4px"
      ></Box>
      <SeekInput
        type="range"
        width="100%"
        min={0}
        max={0.999999}
        step="any"
        value={played}
        onMouseDown={handleSeekMouseDown}
        onChange={handleSeekChange}
        onMouseUp={handleSeekMouseUp}
        onTouchStart={handleSeekMouseDown}
        onTouchEnd={handleSeekMouseUp}
        data-testid="progress-bar"
      />
    </Box>
    <Box
      as="time"
      dateTime={`P${Math.round(played * duration)}S`}
      whiteSpace="nowrap"
      textStyle="body-normal-medium"
      color="white"
      boxShadow="shadow_bottom500"
      data-testid="video-duration"
    >
      {format(played * duration)} / {format(duration)}
    </Box>
  </Box>
);

function format(seconds: number) {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = pad(date.getUTCMinutes());
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${pad(hh)}:${mm}:${ss}`;
  }
  return `${mm}:${ss}`;
}

function pad(number: number) {
  return ('0' + number).slice(-2);
}
